<div class="container">
	<mat-card class="main-card">
		<mat-card-content class="card-content">
			<h3 class="title">{{ 'reset_page.title' | translate }}</h3>

			<form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="login-form">
				<mat-form-field appearance="fill" class="full-width">
					<mat-label>{{ 'reset_page.password_label' | translate }}</mat-label>
					<input
						matInput
						formControlName="password"
						[placeholder]="'reset_page.password_placeholder' | translate"
						type="password"
					/>
				</mat-form-field>

				<mat-form-field appearance="fill" class="full-width">
					<mat-label>{{ 'reset_page.confirm_password_label' | translate }}</mat-label>
					<input
						matInput
						formControlName="rePassword"
						[placeholder]="'reset_page.confirm_password_placeholder' | translate"
						type="password"
					/>
				</mat-form-field>

				<div>
					<button mat-raised-button type="submit" class="submit-button full-width" [disabled]="resetForm.invalid">
						{{ 'reset_page.submit' | translate }}
					</button>
				</div>
			</form>
		</mat-card-content>

		<div class="side-content">
			<div class="logo" style="background-image: url('https://dev-admin.smoothr.de/img/smoothr_logo.def9972e.svg')"></div>
			<p class="description">{{ 'reset_page.description' | translate }}</p>
		</div>
	</mat-card>
</div>
